import "core-js/modules/es6.promise";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.split";
import "regenerator-runtime/runtime";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.function.name";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapMutations, mapState } from 'vuex';
import ApiService from '../../../services/apiService';
import { downloadAttachment } from '../../../utils/vuex';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import pullAt from 'lodash/pullAt';
import NiotaClassicApiService from '../../../services/niotaClassicApiService';
var csvTitleCols = ['title', 'gwEui', 'fireflyGwId', 'originatorId', 'accountId', 'description', 'manufacturer', 'group', 'serialNumber', 'firmwareVersion', 'warningLevel', 'alertLevel', 'latitude', 'longitude', 'address'];
export default {
  name: 'NiotaClassicGwMgmtCsvImport',
  props: {
    accounts: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    isOpen: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      isBatchCreating: false,
      creatingIndex: -1,
      importValidForm: false,
      originators: [],
      gateways: [],
      prefilterError: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'permissions'])), {}, {
    creationProgress: function creationProgress() {
      return Math.floor((this.creatingIndex + 1) / this.gateways.length * 100);
    },
    tableHeaders: function tableHeaders() {
      return [{
        sortable: false,
        text: this.$i18n_t('NiotaClassic.GWMonitoring.csvCreate.line'),
        value: 'idx'
      }, {
        sortable: false,
        text: this.$i18n_t('NiotaClassic.Common.table.title'),
        value: 'title'
      }, {
        sortable: false,
        text: this.$i18n_t('NiotaClassic.GWMonitoring.gwEui')
      }, {
        sortable: false,
        text: this.$i18n_t('NiotaClassic.GWMonitoring.form.fireflyGwId')
      }, {
        sortable: false,
        text: this.$i18n_t('NiotaClassic.Originators.title')
      }, {
        sortable: false,
        text: this.$i18n_t('NiotaClassic.GWMonitoring.account')
      }, {
        sortable: false,
        text: this.$i18n_t('NiotaClassic.GWMonitoring.form.manufacturer')
      }, {
        sortable: false,
        text: this.$i18n_t('Common.lat')
      }, {
        sortable: false,
        text: this.$i18n_t('Common.lon')
      }];
    },
    tableFooterProps: function tableFooterProps() {
      return {
        itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
        itemsPerPageOptions: [5, 10, 20]
      };
    },
    filteredRows: function filteredRows() {
      return this.prefilterError ? this.gateways.filter(function (gw) {
        return gw.error;
      }) : this.gateways;
    }
  }),
  created: function created() {
    var _this = this;

    NiotaClassicApiService.originatorsFetchPlain().then(function (res) {
      _this.originators = res.data.originators;
    }).catch(function () {
      _this.$snack(_this.$i18n_t('NiotaClassic.Devices.snacks.errorFindingOriginators'), 'error');
    });
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('app', ['snackbar'])), {}, {
    get: get,
    accountForId: function accountForId(accountId) {
      return (this.accounts.find(function (a) {
        return a.id === accountId;
      }) || {
        name: this.$i18n_t('NiotaClassic.GWMonitoring.csvCreate.accountUnknown')
      }).name;
    },
    originatorForId: function originatorForId(originatorId) {
      return (this.originators.find(function (d) {
        return d.id === originatorId;
      }) || {
        title: this.$i18n_t('NiotaClassic.GWMonitoring.csvCreate.accountUnknown')
      }).title;
    },
    downloadSampleCsv: function downloadSampleCsv() {
      var colSeparator = ',';
      var csvData = ["".concat(csvTitleCols.join(colSeparator)), "".concat(['Gateway name to create', '00000008004A718F', null, 9001, 1, 'Description without commas or linebreaks', 'DHARMA Initiative', 'Demo Group', 'A0001', '1-02-42a', 5, 12, 50.0987654321, 8.123456789, 'Storgata 4 | 9008 Tromsø | Norway'].join(colSeparator)), "".concat(['Gateway name to import from Firefly', null, 12, 9001, 1, 'Description without commas or linebreaks', 'DHARMA Initiative', 'Demo Group', 'A0001', '1-02-42a', 5, 12, 50.0987654321, 8.123456789, 'Storgata 4 | 9008 Tromsø | Norway'].join(colSeparator))].join('\n');
      var fileName = 'create-n2-gateways.csv';
      downloadAttachment('text/plain;charset=utf-8', csvData, fileName);
    },
    uploadedFile: function () {
      var _uploadedFile = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(csv) {
        var _this2 = this;

        var lines, colSeparator, headerIdxs;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                lines = csv.split('\n');

                if (!(lines.length <= 1)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                this.gateways = [];
                colSeparator = ','; // let header = lines[0].trim().split(colSeparator);

                pullAt(lines, [0]);
                headerIdxs = {};
                csvTitleCols.forEach(function (item, idx) {
                  headerIdxs[item] = idx;
                });
                lines.forEach(function (line, idx) {
                  var parts = line.trim().split(colSeparator);

                  if (parts.length >= 6) {
                    var gwData = {};
                    gwData.idx = idx + 1;
                    gwData.title = parts[headerIdxs['title']];
                    var euiRegex = /^([0-9A-F]{16})$/gi;
                    gwData.eui = euiRegex.exec(parts[headerIdxs['gwEui']].trim()) !== null ? parts[headerIdxs['gwEui']].trim() : null;
                    gwData.fireflyGwId = gwData.eui ? null : parseInt(parts[headerIdxs['fireflyGwId']]) || null;
                    gwData.accountId = parseInt(parts[headerIdxs['accountId']]);
                    gwData.description = parts[headerIdxs['description']];
                    gwData.properties = {
                      originator: {
                        id: parseInt(parts[headerIdxs['originatorId']])
                      },
                      manufacturer: parts[headerIdxs['manufacturer']],
                      serialNr: parts[headerIdxs['serialNumber']],
                      firmwareVersion: parts[headerIdxs['firmwareVersion']],
                      group: parts[headerIdxs['group']],
                      threshold: {
                        green: get(parts, "[".concat(headerIdxs['warningLevel'], "]")),
                        yellow: get(parts, "[".concat(headerIdxs['alertLevel'], "]"))
                      },
                      formatted_address: get(parts, "[".concat(headerIdxs['address'], "]"))
                    };

                    if (!gwData.title.trim()) {
                      gwData.error = (gwData.error || []).concat([_this2.$i18n_t('NiotaClassic.GWMonitoring.csvCreate.errors.titleMissing')]);
                    }

                    if (!gwData.eui && (gwData.fireflyGwId === null || isNaN(gwData.fireflyGwId))) {
                      gwData.error = (gwData.error || []).concat([_this2.$i18n_t('NiotaClassic.GWMonitoring.csvCreate.errors.euiMissing')]);
                    }

                    if (!gwData.accountId || !_this2.accounts.find(function (a) {
                      return a.id === gwData.accountId;
                    })) {
                      gwData.error = (gwData.error || []).concat([_this2.$i18n_t('NiotaClassic.GWMonitoring.csvCreate.errors.accountMissing')]);
                    }

                    if (!gwData.properties.originator.id || isNaN(gwData.properties.originator.id) || !_this2.originators.find(function (d) {
                      return d.id === gwData.properties.originator.id;
                    })) {
                      gwData.error = (gwData.error || []).concat([_this2.$i18n_t('NiotaClassic.GWMonitoring.csvCreate.errors.originatorMissing')]);
                    }

                    if (!isNaN(parseFloat(get(parts, "[".concat(headerIdxs['latitude'], "]")))) && !isNaN(parseFloat(get(parts, "[".concat(headerIdxs['longitude'], "]"))))) {
                      gwData.coordinates = {
                        coordinates: [parseFloat(parts[headerIdxs['longitude']]), parseFloat(parts[headerIdxs['latitude']])]
                      };
                    } else {
                      gwData.coordinates = null;
                    }

                    _this2.gateways.push(gwData);
                  }
                });
                this.gateways = cloneDeep(this.gateways);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function uploadedFile(_x) {
        return _uploadedFile.apply(this, arguments);
      }

      return uploadedFile;
    }(),
    printError: function printError(gateway) {
      if (get(gateway, 'error.message')) {
        var msgKey = "NiotaClassic.GWMonitoring.csvCreate.errors.".concat(get(gateway, 'error.response.data.message'));
        return this.$i18n_t(msgKey) !== msgKey ? this.$i18n_t(msgKey) : "".concat(get(gateway, 'error.message'), " ").concat(get(gateway, 'error.response.data.message'));
      }

      return gateway.error.join ? gateway.error.join(', ') : gateway.error;
    },
    resetGatewayError: function resetGatewayError(index) {
      delete this.gateways[index].error;
      this.gateways = cloneDeep(this.gateways);
    },
    removeGateway: function removeGateway(index) {
      pullAt(this.gateways, [index]);
      this.gateways = cloneDeep(this.gateways);
    },
    createGateways: function createGateways() {
      this.creatingIndex = 0;
      this.isBatchCreating = true;
      this.createSingleGatewayOrStop();
    },
    createSingleGatewayOrStop: function createSingleGatewayOrStop() {
      var _this3 = this;

      var index = this.creatingIndex;

      if (index >= this.gateways.length) {
        var i = 0;

        while (i < this.gateways.length) {
          if (this.gateways[i].id) {
            pullAt(this.gateways, [i]);
          } else {
            i++;
          }
        }

        this.gateways = cloneDeep(this.gateways);
        this.isBatchCreating = false;

        if (this.gateways.length === 0) {
          this.$snack(this.$i18n_t('NiotaClassic.GWMonitoring.snacks.createSuccess'), 'success');
          this.$emit('close');
        }

        return;
      }

      var gwData = this.gateways[index];
      ApiService.gwMgmtCreate(gwData).then(function (response) {
        gwData.id = response.id;
      }).catch(function (error) {
        gwData.error = error;

        _this3.$snack(_this3.$i18n_t('NiotaClassic.GWMonitoring.snacks.createFailed'), 'error');

        console.error(error);
      }).finally(function () {
        _this3.creatingIndex++;
        _this3.gateways = cloneDeep(_this3.gateways);

        _this3.createSingleGatewayOrStop();
      });
    }
  })
};